
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.35 10.04a7.492 7.492 0 00-14-2A6 6 0 006 20h13a4.986 4.986 0 00.35-9.96zM17 13l-4.65 4.65a.5.5 0 01-.71 0L7 13h3V9h4v4h3z"}})])
          )
        }
      }
    